/* eslint-disable @typescript-eslint/naming-convention */
/**
 * Feature flags lookup table.
 * This is used to avoid magic strings in *.ts files code.
 */
export enum FeatureFlagsMap {
  FFActionsNNG = 'actionsNNG',
  FFKleanMenu = 'kleanMenu',
  FFLaundryVertical = 'laundry',
  FFUserOrganizationDPA = 'userOrganizationDPA',
  FFWatsonLaundryPlus = 'watsonLaundryPlus',
  FFWatsonRegularUser = 'watsonRegularUser',
  FFEntGTMTracking = 'entGTMTracking',
  FFEntHideAddons = 'entHideAddons',
  FFGeneralNewBGFrame = 'generalNewBGFrame',
  FFUserServiceOrgApproval = 'userServiceOrgApproval'
}
